import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import MetisMenu from 'metismenujs';

import { SysaMenu, AdminMenu, CashierMenu, WaiterMenu } from './menu';
import { MenuItem } from './menu.model';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  // @ViewChild('sidebarToggler') sidebarToggler: ElementRef;

  // menuItems: MenuItem[] = [];
  // @ViewChild('sidebarMenu') sidebarMenu: ElementRef;

  // constructor(@Inject(DOCUMENT) private document: Document, private renderer: Renderer2, router: Router) {
  //   router.events.forEach((event) => {
  //     if (event instanceof NavigationEnd) {

  //       /**
  //        * Activating the current active item dropdown
  //        */
  //       this._activateMenuDropdown();

  //       /**
  //        * closing the sidebar
  //        */
  //       if (window.matchMedia('(max-width: 991px)').matches) {
  //         this.document.body.classList.remove('sidebar-open');
  //       }

  //     }
  //   });
  // }

  // ngOnInit(): void {
  //   this.LoadMenuItems();

  //   /**
  //    * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
  //    */
  //   const desktopMedium = window.matchMedia('(min-width:992px) and (max-width: 1199px)');
  //   desktopMedium.addEventListener('change', () => {
  //     this.iconSidebar;
  //   });
  //   this.iconSidebar(desktopMedium);
  // }

  // LoadMenuItems() {
  //   let idRole = sessionStorage.idRole;

  //   this.menuItems = idRole == 'ADMI' ? AdminMenu : (idRole == 'CAJE' ? CashierMenu : WaiterMenu);
  // }

  // ngAfterViewInit() {
  //   // activate menu item
  //   new MetisMenu(this.sidebarMenu.nativeElement);

  //   this._activateMenuDropdown();
  // }

  // /**
  //  * Toggle sidebar on hamburger button click
  //  */
  // toggleSidebar(e: Event) {
  //   this.sidebarToggler.nativeElement.classList.toggle('active');
  //   this.sidebarToggler.nativeElement.classList.toggle('not-active');
  //   if (window.matchMedia('(min-width: 992px)').matches) {
  //     e.preventDefault();
  //     this.document.body.classList.toggle('sidebar-folded');
  //   } else if (window.matchMedia('(max-width: 991px)').matches) {
  //     e.preventDefault();
  //     this.document.body.classList.toggle('sidebar-open');
  //   }
  // }


  // /**
  //  * Toggle settings-sidebar 
  //  */
  // toggleSettingsSidebar(e: Event) {
  //   e.preventDefault();
  //   this.document.body.classList.toggle('settings-open');
  // }


  // /**
  //  * Open sidebar when hover (in folded folded state)
  //  */
  // operSidebarFolded() {
  //   if (this.document.body.classList.contains('sidebar-folded')) {
  //     this.document.body.classList.add("open-sidebar-folded");
  //   }
  // }


  // /**
  //  * Fold sidebar after mouse leave (in folded state)
  //  */
  // closeSidebarFolded() {
  //   if (this.document.body.classList.contains('sidebar-folded')) {
  //     this.document.body.classList.remove("open-sidebar-folded");
  //   }
  // }

  // /**
  //  * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
  //  */
  // iconSidebar(mq: MediaQueryList) {
  //   if (mq.matches) {
  //     this.document.body.classList.add('sidebar-folded');
  //   } else {
  //     this.document.body.classList.remove('sidebar-folded');
  //   }
  // }


  // /**
  //  * Switching sidebar light/dark
  //  */
  // onSidebarThemeChange(event: Event) {
  //   this.document.body.classList.remove('sidebar-light', 'sidebar-dark');
  //   this.document.body.classList.add((<HTMLInputElement>event.target).value);
  //   this.document.body.classList.remove('settings-open');
  // }


  // /**
  //  * Returns true or false if given menu item has child or not
  //  * @param item menuItem
  //  */
  // hasItems(item: MenuItem) {
  //   return item.subItems !== undefined ? item.subItems.length > 0 : false;
  // }


  // /**
  //  * Reset the menus then hilight current active menu item
  //  */
  // _activateMenuDropdown() {
  //   this.resetMenuItems();
  //   this.activateMenuItems();
  // }


  // /**
  //  * Resets the menus
  //  */
  // resetMenuItems() {

  //   const links = document.getElementsByClassName('nav-link-ref');

  //   for (let i = 0; i < links.length; i++) {
  //     const menuItemEl = links[i];
  //     menuItemEl.classList.remove('mm-active');
  //     const parentEl = menuItemEl.parentElement;

  //     if (parentEl) {
  //       parentEl.classList.remove('mm-active');
  //       const parent2El = parentEl.parentElement;

  //       if (parent2El) {
  //         parent2El.classList.remove('mm-show');
  //       }

  //       const parent3El = parent2El?.parentElement;
  //       if (parent3El) {
  //         parent3El.classList.remove('mm-active');

  //         if (parent3El.classList.contains('side-nav-item')) {
  //           const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

  //           if (firstAnchor) {
  //             firstAnchor.classList.remove('mm-active');
  //           }
  //         }

  //         const parent4El = parent3El.parentElement;
  //         if (parent4El) {
  //           parent4El.classList.remove('mm-show');

  //           const parent5El = parent4El.parentElement;
  //           if (parent5El) {
  //             parent5El.classList.remove('mm-active');
  //           }
  //         }
  //       }
  //     }
  //   }
  // };


  // /**
  //  * Toggles the menu items
  //  */
  // activateMenuItems() {

  //   const links: any = document.getElementsByClassName('nav-link-ref');

  //   let menuItemEl = null;

  //   for (let i = 0; i < links.length; i++) {
  //     // tslint:disable-next-line: no-string-literal
  //     if (window.location.pathname === links[i]['pathname']) {

  //       menuItemEl = links[i];

  //       break;
  //     }
  //   }

  //   if (menuItemEl) {
  //     menuItemEl.classList.add('mm-active');
  //     const parentEl = menuItemEl.parentElement;

  //     if (parentEl) {
  //       parentEl.classList.add('mm-active');

  //       const parent2El = parentEl.parentElement;
  //       if (parent2El) {
  //         parent2El.classList.add('mm-show');
  //       }

  //       const parent3El = parent2El.parentElement;
  //       if (parent3El) {
  //         parent3El.classList.add('mm-active');

  //         if (parent3El.classList.contains('side-nav-item')) {
  //           const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

  //           if (firstAnchor) {
  //             firstAnchor.classList.add('mm-active');
  //           }
  //         }

  //         const parent4El = parent3El.parentElement;
  //         if (parent4El) {
  //           parent4El.classList.add('mm-show');

  //           const parent5El = parent4El.parentElement;
  //           if (parent5El) {
  //             parent5El.classList.add('mm-active');
  //           }
  //         }
  //       }
  //     }
  //   }
  // };

  menuItems: MenuItem[] = [];
  userName: string = '';
  userRole: string = '';
  userInitial: string = '';
  currentRoute: string = '';
  openSubmenuLabel: string | null = null;
  sidebarOpen = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects || event.url;
        this.autoExpandSubmenu();
        if (window.matchMedia('(max-width: 991px)').matches) {
          this.closeSidebar();
        }
      }
    });
  }

  ngOnInit(): void {
    this.loadMenuItems();
    this.loadUserInfo();
  }

  loadMenuItems(): void {
    const idRole = sessionStorage.getItem('idRole');
    switch (idRole) {
      case 'SYSA': this.menuItems = SysaMenu; break;
      case 'ADMI': this.menuItems = AdminMenu; break;
      case 'CAJE': this.menuItems = CashierMenu; break;
      case 'MOZO': this.menuItems = WaiterMenu; break;
      default:     this.menuItems = WaiterMenu; break;
    }
  }

  loadUserInfo(): void {
    const name = sessionStorage.getItem('name') || '';
    const lastName = sessionStorage.getItem('lastName') || '';
    this.userName = `${name} ${lastName}`.trim() || 'Usuario';
    this.userInitial = this.userName.charAt(0).toUpperCase();

    const idRole = sessionStorage.getItem('idRole');
    const roleMap: { [key: string]: string } = {
      'SYSA': 'Super Admin',
      'ADMI': 'Administrador',
      'CAJE': 'Cajero',
      'MOZO': 'Mesero',
    };
    this.userRole = roleMap[idRole || ''] || 'Usuario';
  }

  toggleSubmenu(item: MenuItem): void {
    if (this.openSubmenuLabel === item.label) {
      this.openSubmenuLabel = null;
    } else {
      this.openSubmenuLabel = item.label || null;
    }
  }

  isSubmenuOpen(item: MenuItem): boolean {
    return this.openSubmenuLabel === item.label;
  }

  isActive(link: string | undefined): boolean {
    if (!link) return false;
    const normalizedLink = link.startsWith('/') ? link : '/' + link;
    if (this.currentRoute === normalizedLink) return true;
    // Solo marcar como activo por prefijo si NO existe otro ítem del menú
    // cuyo link coincida más específicamente con la ruta actual.
    if (!this.currentRoute.startsWith(normalizedLink + '/')) return false;
    const hasMoreSpecific = this.menuItems.some((it: MenuItem) => {
      const candidates: (string | undefined)[] = [it.link, ...(it.subItems?.map(s => s.link) || [])];
      return candidates.some(l => {
        if (!l) return false;
        const n = l.startsWith('/') ? l : '/' + l;
        return n !== normalizedLink && n.length > normalizedLink.length &&
          (this.currentRoute === n || this.currentRoute.startsWith(n + '/'));
      });
    });
    return !hasMoreSpecific;
  }

  isParentActive(item: MenuItem): boolean {
    if (item.link) return this.isActive(item.link);
    if (item.subItems) {
      return item.subItems.some((sub: MenuItem) => this.isActive(sub.link));
    }
    return false;
  }

  hasItems(item: MenuItem): boolean {
    return item.subItems !== undefined && item.subItems.length > 0;
  }

  toggleSidebar(e?: Event): void {
    if (e) e.preventDefault();
    // Comportamiento doble:
    //   - Mobile (≤ 991px): el sidebar es overlay y se abre/cierra con
    //     la clase `fg-sidebar-open` en el body.
    //   - Desktop: el sidebar se "colapsa" (sale del flujo) con la
    //     clase `fg-sidebar-collapsed`; el contenido principal toma
    //     todo el ancho.
    const isMobile = window.matchMedia('(max-width: 991px)').matches;
    if (isMobile) {
      this.sidebarOpen = !this.sidebarOpen;
      if (this.sidebarOpen) {
        this.document.body.classList.add('fg-sidebar-open');
      } else {
        this.document.body.classList.remove('fg-sidebar-open');
      }
    } else {
      this.document.body.classList.toggle('fg-sidebar-collapsed');
    }
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
    this.document.body.classList.remove('fg-sidebar-open');
  }

  private autoExpandSubmenu(): void {
    for (const item of this.menuItems) {
      if (item.subItems) {
        for (const sub of item.subItems) {
          if (this.isActive(sub.link)) {
            this.openSubmenuLabel = item.label || null;
            return;
          }
        }
      }
    }
  }
}